import React from "react";
import "./SubscribeModal.css";

const SubscribeModal = ({ isOpen, onClose, selectedPlan }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Subscribe to {selectedPlan}</h2>
        <p>Please fill in your contact details. We'll reach out to complete setup.</p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            // TODO: Send data to backend or email
            alert("Submitted! We'll contact you shortly.");
            onClose();
          }}
        >
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="tel" placeholder="Phone Number" required />
          <button type="submit" className="btn">Submit</button>
        </form>

        <button onClick={onClose} className="close-btn">×</button>
      </div>
    </div>
  );
};

export default SubscribeModal;
